@use "../../variables" as *;

.custom-filter,
.default-filter,
.like-filter {
  > span {
    cursor: pointer;
  }

  > a {
    text-decoration: inherit;
    color: inherit;
  }

  &.selected {
    font-weight: 400;
    color: $grey-text;
  }

  .filter-selected-icon {
    margin-left: 0.5rem;

    svg {
      fill: $grey;
    }
  }
}

.custom-filter {
  text-transform: uppercase;
  font-size: 1.125rem;
  letter-spacing: 0.05rem;
  margin-bottom: 0.75rem;

  svg {
    fill: $grey;
    width: 1.125rem;
    height: 1.125rem;
  }
}

.sale-filter {
  color: #e4172e;
  font-size: 1.6rem;
  font-weight: 900;

  &.selected {
    color: #e4172e;
    font-weight: 900;
  }
}

.default-filter {
  font-size: 1rem;
  line-height: 1rem;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;

  svg {
    width: 1rem;
    height: 1rem;
  }

  .sub-filter {
    margin-left: 1rem;
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }
}

.like-filter {
  display: inline;

  .heart {
    margin-right: 0.5rem;
    vertical-align: middle;

    svg {
      width: 1.125rem;
      height: 1.125rem;
    }

    &.fill span {
      fill: $ny-red;
    }
  }

  .likes-count {
    margin-left: 0.5rem;
  }
}

.bubble-filter-wrapper {
  text-decoration: none;

  .bubble-filter {
    padding: 0 0.5rem;
    font-weight: 400;
    color: $grey-text;
    text-align: center;

    &.few {
      padding: 0 0.75rem;
    }

    img {
      width: 4rem;
      height: 4rem;
      border-radius: 3rem;
      outline: none;
      border: none;
    }

    .bubble-editorial-name {
      font-size: 0.9rem;
      text-align: center;
      margin-top: 0.25rem;
    }
  }
}
